<template>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"> 
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H7V7H0V0ZM0 9H7V16H0V9ZM7 18H0V25H7V18ZM9 0H16V7H9V0ZM16 9H9V16H16V9ZM9 18H16V25H9V18ZM25 0H18V7H25V0ZM18 9H25V16H18V9ZM25 18H18V25H25V18Z" :fill="fill"/>
    </svg>
</template>
<script>
export default {
    name: 'MenuIcon',
    props:{
        fill: {
            type: String,
            default: '#FBBC05'
        }
    }
};
</script>